
import { mapState } from 'vuex'

export default {
  head() {
    return this.$metadata(this.story)
  },
  data() {
    return {
      story: {}
    }
  },
  mounted() {    
    const eventData = {
      event: 'view_menu',
      currency: 'USD'
    }

    if (this.order && this.order.products) {
      eventData.items = this.order.products
      eventData.value = this.order.totals.total
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      ...eventData
    });

    this.$storybridge.on(['input', 'published', 'change'], (event) => {
      if (event.action === 'input') {
        if (event.story.id === this.story.id) {
          this.story.content = event.story.content
        }
      } else {
        window.location.reload()
      }
    })
    if (!this.menu) {
      this.$router.push('/locations')
    }
  },
  async asyncData({ $storyapi, store, route }) {
    try {
      const { data } = await $storyapi.get(`cdn/stories/${route.name}`, {
        version: process.env.SB_VERSION
      })
      return {
        story: data.story
      }
    } catch (error) {
      console.error(error)
    }
  },
  computed: {
    ...mapState(['menu', 'order', 'channel'])
  },
}
